import { render, staticRenderFns } from "./VanTaiKhachForm.vue?vue&type=template&id=0a770fc8"
import script from "./VanTaiKhachForm.vue?vue&type=script&lang=js"
export * from "./VanTaiKhachForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports